var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderAssignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.4 50.9001C101.4 65.1001 95.6 77.9001 86.3 87.1001C77.2 96.2001 64.6 101.7 50.7 101.7C36.9 101.7 24.3 96.1001 15.1 87.1001C5.8 77.9001 0 65.1001 0 50.9001C0 22.8001 22.7 0.100098 50.7 0.100098C78.7 0.100098 101.4 22.9001 101.4 50.9001Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3 24.3003V87.1003C77.2 96.2003 64.6 101.7 50.7 101.7C36.9 101.7 24.3 96.1003 15.1 87.1003V24.3003H86.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.9578 56.3537L38.0279 42.4238L33.2903 47.1614L47.2202 61.0913L51.9578 56.3537Z",
    fill: "#979FAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3833 35.4989L42.5946 56.2876L47.3322 61.0252L68.1209 40.2364L63.3833 35.4989Z",
    fill: "#979FAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 69.6001H32.5V74.2001H68.9V69.6001Z",
    fill: "#D5DAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 79.7002H32.5V84.3002H68.9V79.7002Z",
    fill: "#D5DAE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89.8999H41.4V94.4999H60V89.8999Z",
    fill: "#D5DAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAssignedIcon);
export default __webpack_public_path__ + "static/media/orderAssignedIcon.12974efb08189c7a138f2666c6736864.svg";
export { ForwardRef as ReactComponent };